/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_TenantManagementApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_TenantManagementApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class TenantManagementApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_TenantManagementApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_TenantManagementApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    /**
     * @return OK
     */
    configGET(signal?: AbortSignal): AxiosPromise<ApplicationConfigs> {
        let url_ = "/api/tm/app/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<ApplicationConfigs>(options_);
    }

    /**
     * @partitionIdOrName (optional) 
     * @page (optional) 
     * @pageSize (optional) 
     * @isAscending (optional) 
     * @sortingField (optional) 
     * @return OK
     */
    all(tenantId: string, partitionIdOrName: string | undefined, page: number | undefined, pageSize: number | undefined, isAscending: boolean | undefined, sortingField: string | undefined, signal?: AbortSignal): AxiosPromise<PartitionOverview> {
        let url_ = "/api/tm/partition/all/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (partitionIdOrName === null)
            throw new Error("The parameter 'partitionIdOrName' cannot be null.");
        else if (partitionIdOrName !== undefined)
            url_ += "partitionIdOrName=" + encodeURIComponent("" + partitionIdOrName) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "isAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (sortingField === null)
            throw new Error("The parameter 'sortingField' cannot be null.");
        else if (sortingField !== undefined)
            url_ += "sortingField=" + encodeURIComponent("" + sortingField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<PartitionOverview>(options_);
    }

    /**
     * @partner (optional) 
     * @tenantId (optional) 
     * @partitionId (optional) 
     * @return OK
     */
    partitionGET(partner: string | undefined, tenantId: string | undefined, partitionId: string | undefined, signal?: AbortSignal): AxiosPromise<PartitionDetail> {
        let url_ = "/api/tm/partition?";
        if (partner === null)
            throw new Error("The parameter 'partner' cannot be null.");
        else if (partner !== undefined)
            url_ += "partner=" + encodeURIComponent("" + partner) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (partitionId === null)
            throw new Error("The parameter 'partitionId' cannot be null.");
        else if (partitionId !== undefined)
            url_ += "partitionId=" + encodeURIComponent("" + partitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<PartitionDetail>(options_);
    }

    /**
     * @internalTenantId (optional) 
     * @internalPartitionId (optional) 
     * @return OK
     */
    partitionDELETE(internalTenantId: string | undefined, internalPartitionId: string | undefined, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/tm/partition?";
        if (internalTenantId === null)
            throw new Error("The parameter 'internalTenantId' cannot be null.");
        else if (internalTenantId !== undefined)
            url_ += "internalTenantId=" + encodeURIComponent("" + internalTenantId) + "&";
        if (internalPartitionId === null)
            throw new Error("The parameter 'internalPartitionId' cannot be null.");
        else if (internalPartitionId !== undefined)
            url_ += "internalPartitionId=" + encodeURIComponent("" + internalPartitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @return OK
     */
    restore(internalPartitionId: string, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/tm/partition/restore/{internalPartitionId}";
        if (internalPartitionId === undefined || internalPartitionId === null)
            throw new Error("The parameter 'internalPartitionId' must be defined.");
        url_ = url_.replace("{internalPartitionId}", encodeURIComponent("" + internalPartitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @body (optional) 
     * @return OK
     */
    configPOST(internalPartitionId: string, body: EntityConfig | undefined, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/tm/partition/{internalPartitionId}/config";
        if (internalPartitionId === undefined || internalPartitionId === null)
            throw new Error("The parameter 'internalPartitionId' must be defined.");
        url_ = url_.replace("{internalPartitionId}", encodeURIComponent("" + internalPartitionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @return OK
     */
    getPartitionConfigs(internalPartitionId: string, signal?: AbortSignal): AxiosPromise<{ [key: string]: any; }> {
        let url_ = "/api/tm/partition/{internalPartitionId}/config";
        if (internalPartitionId === undefined || internalPartitionId === null)
            throw new Error("The parameter 'internalPartitionId' must be defined.");
        url_ = url_.replace("{internalPartitionId}", encodeURIComponent("" + internalPartitionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<{ [key: string]: any; }>(options_);
    }

    /**
     * @body (optional) 
     * @return OK
     */
    configPUT(internalPartitionId: string, body: PartitionInput | undefined, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/tm/partition/{internalPartitionId}/config";
        if (internalPartitionId === undefined || internalPartitionId === null)
            throw new Error("The parameter 'internalPartitionId' must be defined.");
        url_ = url_.replace("{internalPartitionId}", encodeURIComponent("" + internalPartitionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            data: content_,
            url: url_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @return OK
     */
    name(internalPartitionId: string, name: string, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/tm/partition/{internalPartitionId}/config/name/{name}";
        if (internalPartitionId === undefined || internalPartitionId === null)
            throw new Error("The parameter 'internalPartitionId' must be defined.");
        url_ = url_.replace("{internalPartitionId}", encodeURIComponent("" + internalPartitionId));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @return OK
     */
    allAll(signal?: AbortSignal): AxiosPromise<PartnerOverview[]> {
        let url_ = "/api/tm/partner/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<PartnerOverview[]>(options_);
    }

    /**
     * @return OK
     */
    partner(externalPartnerId: string, signal?: AbortSignal): AxiosPromise<PartnerDetail> {
        let url_ = "/api/tm/partner/{externalPartnerId}";
        if (externalPartnerId === undefined || externalPartnerId === null)
            throw new Error("The parameter 'externalPartnerId' must be defined.");
        url_ = url_.replace("{externalPartnerId}", encodeURIComponent("" + externalPartnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<PartnerDetail>(options_);
    }

    /**
     * @return OK
     */
    restore2(internalPartnerId: string, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/tm/partner/restore/{internalPartnerId}";
        if (internalPartnerId === undefined || internalPartnerId === null)
            throw new Error("The parameter 'internalPartnerId' must be defined.");
        url_ = url_.replace("{internalPartnerId}", encodeURIComponent("" + internalPartnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @body (optional) 
     * @return OK
     */
    configPOST2(internalPartnerId: string, body: EntityConfig | undefined, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/tm/partner/{internalPartnerId}/config";
        if (internalPartnerId === undefined || internalPartnerId === null)
            throw new Error("The parameter 'internalPartnerId' must be defined.");
        url_ = url_.replace("{internalPartnerId}", encodeURIComponent("" + internalPartnerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @return OK
     */
    getPartnerConfigs(internalPartnerId: string, signal?: AbortSignal): AxiosPromise<{ [key: string]: any; }> {
        let url_ = "/api/tm/partner/{internalPartnerId}/config";
        if (internalPartnerId === undefined || internalPartnerId === null)
            throw new Error("The parameter 'internalPartnerId' must be defined.");
        url_ = url_.replace("{internalPartnerId}", encodeURIComponent("" + internalPartnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<{ [key: string]: any; }>(options_);
    }

    /**
     * @body (optional) 
     * @return OK
     */
    configPUT2(internalPartnerId: string, body: PartnerInput | undefined, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/tm/partner/{internalPartnerId}/config";
        if (internalPartnerId === undefined || internalPartnerId === null)
            throw new Error("The parameter 'internalPartnerId' must be defined.");
        url_ = url_.replace("{internalPartnerId}", encodeURIComponent("" + internalPartnerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            data: content_,
            url: url_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @return OK
     */
    name2(internalPartnerId: string, name: string, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/tm/partner/{internalPartnerId}/config/name/{name}";
        if (internalPartnerId === undefined || internalPartnerId === null)
            throw new Error("The parameter 'internalPartnerId' must be defined.");
        url_ = url_.replace("{internalPartnerId}", encodeURIComponent("" + internalPartnerId));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @tenantIdOrName (optional) 
     * @partnerIds (optional) 
     * @statuses (optional) 
     * @page (optional) 
     * @pageSize (optional) 
     * @isAscending (optional) 
     * @sortingField (optional) 
     * @return OK
     */
    all2(tenantIdOrName: string | undefined, partnerIds: string[] | undefined, statuses: TenantStatus[] | undefined, page: number | undefined, pageSize: number | undefined, isAscending: boolean | undefined, sortingField: string | undefined, signal?: AbortSignal): AxiosPromise<TenantOverview> {
        let url_ = "/api/tm/Tenant/all?";
        if (tenantIdOrName === null)
            throw new Error("The parameter 'tenantIdOrName' cannot be null.");
        else if (tenantIdOrName !== undefined)
            url_ += "tenantIdOrName=" + encodeURIComponent("" + tenantIdOrName) + "&";
        if (partnerIds === null)
            throw new Error("The parameter 'partnerIds' cannot be null.");
        else if (partnerIds !== undefined)
            partnerIds && partnerIds.forEach(item => { url_ += "partnerIds=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (isAscending === null)
            throw new Error("The parameter 'isAscending' cannot be null.");
        else if (isAscending !== undefined)
            url_ += "isAscending=" + encodeURIComponent("" + isAscending) + "&";
        if (sortingField === null)
            throw new Error("The parameter 'sortingField' cannot be null.");
        else if (sortingField !== undefined)
            url_ += "sortingField=" + encodeURIComponent("" + sortingField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<TenantOverview>(options_);
    }

    /**
     * @partner (optional) 
     * @tenantId (optional) 
     * @return OK
     */
    tenant(partner: string | undefined, tenantId: string | undefined, signal?: AbortSignal): AxiosPromise<TenantDetail> {
        let url_ = "/api/tm/Tenant?";
        if (partner === null)
            throw new Error("The parameter 'partner' cannot be null.");
        else if (partner !== undefined)
            url_ += "partner=" + encodeURIComponent("" + partner) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<TenantDetail>(options_);
    }

    /**
     * @return OK
     */
    restore3(internalTenantId: string, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/tm/Tenant/restore/{internalTenantId}";
        if (internalTenantId === undefined || internalTenantId === null)
            throw new Error("The parameter 'internalTenantId' must be defined.");
        url_ = url_.replace("{internalTenantId}", encodeURIComponent("" + internalTenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @body (optional) 
     * @return OK
     */
    configPOST3(internalTenantId: string, body: EntityConfig | undefined, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/tm/tenant/{internalTenantId}/config";
        if (internalTenantId === undefined || internalTenantId === null)
            throw new Error("The parameter 'internalTenantId' must be defined.");
        url_ = url_.replace("{internalTenantId}", encodeURIComponent("" + internalTenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @return OK
     */
    getTenantConfigs(internalTenantId: string, signal?: AbortSignal): AxiosPromise<{ [key: string]: any; }> {
        let url_ = "/api/tm/tenant/{internalTenantId}/config";
        if (internalTenantId === undefined || internalTenantId === null)
            throw new Error("The parameter 'internalTenantId' must be defined.");
        url_ = url_.replace("{internalTenantId}", encodeURIComponent("" + internalTenantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<{ [key: string]: any; }>(options_);
    }

    /**
     * @body (optional) 
     * @return OK
     */
    configPUT3(internalTenantId: string, body: TenantConfig | undefined, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/tm/tenant/{internalTenantId}/config";
        if (internalTenantId === undefined || internalTenantId === null)
            throw new Error("The parameter 'internalTenantId' must be defined.");
        url_ = url_.replace("{internalTenantId}", encodeURIComponent("" + internalTenantId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            data: content_,
            url: url_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }

    /**
     * @return OK
     */
    name3(internalTenantId: string, name: string, signal?: AbortSignal): AxiosPromise<void> {
        let url_ = "/api/tm/tenant/{internalTenantId}/config/name/{name}";
        if (internalTenantId === undefined || internalTenantId === null)
            throw new Error("The parameter 'internalTenantId' must be defined.");
        url_ = url_.replace("{internalTenantId}", encodeURIComponent("" + internalTenantId));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }
}

export class ApplicationConfigs implements IApplicationConfigs {
    environmentTag!: string;

    constructor(data?: IApplicationConfigs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.environmentTag = _data["environmentTag"] !== undefined ? _data["environmentTag"] : <any>null;
        }
    }

    static fromJS(data: any): ApplicationConfigs {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationConfigs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["environmentTag"] = this.environmentTag !== undefined ? this.environmentTag : <any>null;
        return data;
    }
}

export interface IApplicationConfigs {
    environmentTag: string;
}

export class EntityConfig implements IEntityConfig {
    name!: string;
    value!: string | null;

    constructor(data?: IEntityConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): EntityConfig {
        data = typeof data === 'object' ? data : {};
        let result = new EntityConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IEntityConfig {
    name: string;
    value: string | null;
}

export class Partition implements IPartition {
    internalId!: string;
    externalId!: string | null;
    displayName!: string;
    status!: PartitionStatus;

    constructor(data?: IPartition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalId = _data["internalId"] !== undefined ? _data["internalId"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): Partition {
        data = typeof data === 'object' ? data : {};
        let result = new Partition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalId"] = this.internalId !== undefined ? this.internalId : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IPartition {
    internalId: string;
    externalId: string | null;
    displayName: string;
    status: PartitionStatus;
}

export class PartitionConfig implements IPartitionConfig {
    emailScope!: string;
    emailSenderDomain!: string;
    directMailProvider!: string;
    emailTemplateOptOut!: boolean | null;
    generic!: { [key: string]: any; };
    authPath!: string | null;

    constructor(data?: IPartitionConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.generic = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailScope = _data["emailScope"] !== undefined ? _data["emailScope"] : <any>null;
            this.emailSenderDomain = _data["emailSenderDomain"] !== undefined ? _data["emailSenderDomain"] : <any>null;
            this.directMailProvider = _data["directMailProvider"] !== undefined ? _data["directMailProvider"] : <any>null;
            this.emailTemplateOptOut = _data["emailTemplateOptOut"] !== undefined ? _data["emailTemplateOptOut"] : <any>null;
            if (_data["generic"]) {
                this.generic = {} as any;
                for (let key in _data["generic"]) {
                    if (_data["generic"].hasOwnProperty(key))
                        (<any>this.generic)![key] = _data["generic"][key] !== undefined ? _data["generic"][key] : <any>null;
                }
            }
            else {
                this.generic = <any>null;
            }
            this.authPath = _data["authPath"] !== undefined ? _data["authPath"] : <any>null;
        }
    }

    static fromJS(data: any): PartitionConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PartitionConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailScope"] = this.emailScope !== undefined ? this.emailScope : <any>null;
        data["emailSenderDomain"] = this.emailSenderDomain !== undefined ? this.emailSenderDomain : <any>null;
        data["directMailProvider"] = this.directMailProvider !== undefined ? this.directMailProvider : <any>null;
        data["emailTemplateOptOut"] = this.emailTemplateOptOut !== undefined ? this.emailTemplateOptOut : <any>null;
        if (this.generic) {
            data["generic"] = {};
            for (let key in this.generic) {
                if (this.generic.hasOwnProperty(key))
                    (<any>data["generic"])[key] = this.generic[key] !== undefined ? this.generic[key] : <any>null;
            }
        }
        data["authPath"] = this.authPath !== undefined ? this.authPath : <any>null;
        return data;
    }
}

export interface IPartitionConfig {
    emailScope: string;
    emailSenderDomain: string;
    directMailProvider: string;
    emailTemplateOptOut: boolean | null;
    generic: { [key: string]: any; };
    authPath: string | null;
}

export class PartitionDetail implements IPartitionDetail {
    internalId!: string;
    externalId!: string | null;
    displayName!: string;
    status!: PartitionStatus;
    configs!: PartitionConfig;
    tenantDetails!: TenantDetail;

    constructor(data?: IPartitionDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configs = new PartitionConfig();
            this.tenantDetails = new TenantDetail();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalId = _data["internalId"] !== undefined ? _data["internalId"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.configs = _data["configs"] ? PartitionConfig.fromJS(_data["configs"]) : new PartitionConfig();
            this.tenantDetails = _data["tenantDetails"] ? TenantDetail.fromJS(_data["tenantDetails"]) : new TenantDetail();
        }
    }

    static fromJS(data: any): PartitionDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PartitionDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalId"] = this.internalId !== undefined ? this.internalId : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["configs"] = this.configs ? this.configs.toJSON() : <any>null;
        data["tenantDetails"] = this.tenantDetails ? this.tenantDetails.toJSON() : <any>null;
        return data;
    }
}

export interface IPartitionDetail {
    internalId: string;
    externalId: string | null;
    displayName: string;
    status: PartitionStatus;
    configs: PartitionConfig;
    tenantDetails: TenantDetail;
}

export class PartitionInput implements IPartitionInput {
    displayName!: string;
    configs!: PartitionConfig;

    constructor(data?: IPartitionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configs = new PartitionConfig();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.configs = _data["configs"] ? PartitionConfig.fromJS(_data["configs"]) : new PartitionConfig();
        }
    }

    static fromJS(data: any): PartitionInput {
        data = typeof data === 'object' ? data : {};
        let result = new PartitionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["configs"] = this.configs ? this.configs.toJSON() : <any>null;
        return data;
    }
}

export interface IPartitionInput {
    displayName: string;
    configs: PartitionConfig;
}

export class PartitionOverview implements IPartitionOverview {
    count!: number;
    partitions!: Partition[] | null;

    constructor(data?: IPartitionOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"] !== undefined ? _data["count"] : <any>null;
            if (Array.isArray(_data["partitions"])) {
                this.partitions = [] as any;
                for (let item of _data["partitions"])
                    this.partitions!.push(Partition.fromJS(item));
            }
            else {
                this.partitions = <any>null;
            }
        }
    }

    static fromJS(data: any): PartitionOverview {
        data = typeof data === 'object' ? data : {};
        let result = new PartitionOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count !== undefined ? this.count : <any>null;
        if (Array.isArray(this.partitions)) {
            data["partitions"] = [];
            for (let item of this.partitions)
                data["partitions"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface IPartitionOverview {
    count: number;
    partitions: Partition[] | null;
}

export enum PartitionStatus {
    NONE = "NONE",
    NEW = "NEW",
    ONBOARDING = "ONBOARDING",
    ACTIVE = "ACTIVE",
    SUSPENDED = "SUSPENDED",
    DELETED = "DELETED",
}

export class PartnerConfig implements IPartnerConfig {
    emailScope!: string;
    emailSenderDomain!: string;
    directMailProvider!: string;
    emailTemplateOptOut!: boolean | null;
    generic!: { [key: string]: any; };
    isPartnerLevelAuth!: boolean | null;
    authPath!: string | null;
    partnerKBUrl!: string | null;
    supportCallForwarding!: boolean | null;
    managedDomains!: string[] | null;

    constructor(data?: IPartnerConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.generic = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailScope = _data["emailScope"] !== undefined ? _data["emailScope"] : <any>null;
            this.emailSenderDomain = _data["emailSenderDomain"] !== undefined ? _data["emailSenderDomain"] : <any>null;
            this.directMailProvider = _data["directMailProvider"] !== undefined ? _data["directMailProvider"] : <any>null;
            this.emailTemplateOptOut = _data["emailTemplateOptOut"] !== undefined ? _data["emailTemplateOptOut"] : <any>null;
            if (_data["generic"]) {
                this.generic = {} as any;
                for (let key in _data["generic"]) {
                    if (_data["generic"].hasOwnProperty(key))
                        (<any>this.generic)![key] = _data["generic"][key] !== undefined ? _data["generic"][key] : <any>null;
                }
            }
            else {
                this.generic = <any>null;
            }
            this.isPartnerLevelAuth = _data["isPartnerLevelAuth"] !== undefined ? _data["isPartnerLevelAuth"] : <any>null;
            this.authPath = _data["authPath"] !== undefined ? _data["authPath"] : <any>null;
            this.partnerKBUrl = _data["partnerKBUrl"] !== undefined ? _data["partnerKBUrl"] : <any>null;
            this.supportCallForwarding = _data["supportCallForwarding"] !== undefined ? _data["supportCallForwarding"] : <any>null;
            if (Array.isArray(_data["managedDomains"])) {
                this.managedDomains = [] as any;
                for (let item of _data["managedDomains"])
                    this.managedDomains!.push(item);
            }
            else {
                this.managedDomains = <any>null;
            }
        }
    }

    static fromJS(data: any): PartnerConfig {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailScope"] = this.emailScope !== undefined ? this.emailScope : <any>null;
        data["emailSenderDomain"] = this.emailSenderDomain !== undefined ? this.emailSenderDomain : <any>null;
        data["directMailProvider"] = this.directMailProvider !== undefined ? this.directMailProvider : <any>null;
        data["emailTemplateOptOut"] = this.emailTemplateOptOut !== undefined ? this.emailTemplateOptOut : <any>null;
        if (this.generic) {
            data["generic"] = {};
            for (let key in this.generic) {
                if (this.generic.hasOwnProperty(key))
                    (<any>data["generic"])[key] = this.generic[key] !== undefined ? this.generic[key] : <any>null;
            }
        }
        data["isPartnerLevelAuth"] = this.isPartnerLevelAuth !== undefined ? this.isPartnerLevelAuth : <any>null;
        data["authPath"] = this.authPath !== undefined ? this.authPath : <any>null;
        data["partnerKBUrl"] = this.partnerKBUrl !== undefined ? this.partnerKBUrl : <any>null;
        data["supportCallForwarding"] = this.supportCallForwarding !== undefined ? this.supportCallForwarding : <any>null;
        if (Array.isArray(this.managedDomains)) {
            data["managedDomains"] = [];
            for (let item of this.managedDomains)
                data["managedDomains"].push(item);
        }
        return data;
    }
}

export interface IPartnerConfig {
    emailScope: string;
    emailSenderDomain: string;
    directMailProvider: string;
    emailTemplateOptOut: boolean | null;
    generic: { [key: string]: any; };
    isPartnerLevelAuth: boolean | null;
    authPath: string | null;
    partnerKBUrl: string | null;
    supportCallForwarding: boolean | null;
    managedDomains: string[] | null;
}

export class PartnerDetail implements IPartnerDetail {
    internalId!: string;
    externalId!: string;
    displayName!: string;
    configs!: PartnerConfig;

    constructor(data?: IPartnerDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configs = new PartnerConfig();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalId = _data["internalId"] !== undefined ? _data["internalId"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.configs = _data["configs"] ? PartnerConfig.fromJS(_data["configs"]) : new PartnerConfig();
        }
    }

    static fromJS(data: any): PartnerDetail {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalId"] = this.internalId !== undefined ? this.internalId : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["configs"] = this.configs ? this.configs.toJSON() : <any>null;
        return data;
    }
}

export interface IPartnerDetail {
    internalId: string;
    externalId: string;
    displayName: string;
    configs: PartnerConfig;
}

export class PartnerInput implements IPartnerInput {
    name!: string;
    configs!: PartnerConfig;

    constructor(data?: IPartnerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configs = new PartnerConfig();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.configs = _data["configs"] ? PartnerConfig.fromJS(_data["configs"]) : new PartnerConfig();
        }
    }

    static fromJS(data: any): PartnerInput {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["configs"] = this.configs ? this.configs.toJSON() : <any>null;
        return data;
    }
}

export interface IPartnerInput {
    name: string;
    configs: PartnerConfig;
}

export class PartnerOverview implements IPartnerOverview {
    id!: string;
    name!: string;
    tenantsCount!: number;
    configs!: PartnerConfig;

    constructor(data?: IPartnerOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configs = new PartnerConfig();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.tenantsCount = _data["tenantsCount"] !== undefined ? _data["tenantsCount"] : <any>null;
            this.configs = _data["configs"] ? PartnerConfig.fromJS(_data["configs"]) : new PartnerConfig();
        }
    }

    static fromJS(data: any): PartnerOverview {
        data = typeof data === 'object' ? data : {};
        let result = new PartnerOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["tenantsCount"] = this.tenantsCount !== undefined ? this.tenantsCount : <any>null;
        data["configs"] = this.configs ? this.configs.toJSON() : <any>null;
        return data;
    }
}

export interface IPartnerOverview {
    id: string;
    name: string;
    tenantsCount: number;
    configs: PartnerConfig;
}

export class Tenant implements ITenant {
    internalId!: string;
    externalId!: string;
    partnerId!: string;
    partnerName!: string;
    displayName!: string;
    status!: TenantStatus;

    constructor(data?: ITenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalId = _data["internalId"] !== undefined ? _data["internalId"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.partnerId = _data["partnerId"] !== undefined ? _data["partnerId"] : <any>null;
            this.partnerName = _data["partnerName"] !== undefined ? _data["partnerName"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): Tenant {
        data = typeof data === 'object' ? data : {};
        let result = new Tenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalId"] = this.internalId !== undefined ? this.internalId : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["partnerId"] = this.partnerId !== undefined ? this.partnerId : <any>null;
        data["partnerName"] = this.partnerName !== undefined ? this.partnerName : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface ITenant {
    internalId: string;
    externalId: string;
    partnerId: string;
    partnerName: string;
    displayName: string;
    status: TenantStatus;
}

export class TenantConfig implements ITenantConfig {
    emailScope!: string;
    emailSenderDomain!: string;
    directMailProvider!: string;
    emailTemplateOptOut!: boolean | null;
    generic!: { [key: string]: any; };
    authPath!: string | null;
    partnerKBUrl!: string | null;
    warmupDomains!: string[] | null;

    constructor(data?: ITenantConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.generic = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailScope = _data["emailScope"] !== undefined ? _data["emailScope"] : <any>null;
            this.emailSenderDomain = _data["emailSenderDomain"] !== undefined ? _data["emailSenderDomain"] : <any>null;
            this.directMailProvider = _data["directMailProvider"] !== undefined ? _data["directMailProvider"] : <any>null;
            this.emailTemplateOptOut = _data["emailTemplateOptOut"] !== undefined ? _data["emailTemplateOptOut"] : <any>null;
            if (_data["generic"]) {
                this.generic = {} as any;
                for (let key in _data["generic"]) {
                    if (_data["generic"].hasOwnProperty(key))
                        (<any>this.generic)![key] = _data["generic"][key] !== undefined ? _data["generic"][key] : <any>null;
                }
            }
            else {
                this.generic = <any>null;
            }
            this.authPath = _data["authPath"] !== undefined ? _data["authPath"] : <any>null;
            this.partnerKBUrl = _data["partnerKBUrl"] !== undefined ? _data["partnerKBUrl"] : <any>null;
            if (Array.isArray(_data["warmupDomains"])) {
                this.warmupDomains = [] as any;
                for (let item of _data["warmupDomains"])
                    this.warmupDomains!.push(item);
            }
            else {
                this.warmupDomains = <any>null;
            }
        }
    }

    static fromJS(data: any): TenantConfig {
        data = typeof data === 'object' ? data : {};
        let result = new TenantConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailScope"] = this.emailScope !== undefined ? this.emailScope : <any>null;
        data["emailSenderDomain"] = this.emailSenderDomain !== undefined ? this.emailSenderDomain : <any>null;
        data["directMailProvider"] = this.directMailProvider !== undefined ? this.directMailProvider : <any>null;
        data["emailTemplateOptOut"] = this.emailTemplateOptOut !== undefined ? this.emailTemplateOptOut : <any>null;
        if (this.generic) {
            data["generic"] = {};
            for (let key in this.generic) {
                if (this.generic.hasOwnProperty(key))
                    (<any>data["generic"])[key] = this.generic[key] !== undefined ? this.generic[key] : <any>null;
            }
        }
        data["authPath"] = this.authPath !== undefined ? this.authPath : <any>null;
        data["partnerKBUrl"] = this.partnerKBUrl !== undefined ? this.partnerKBUrl : <any>null;
        if (Array.isArray(this.warmupDomains)) {
            data["warmupDomains"] = [];
            for (let item of this.warmupDomains)
                data["warmupDomains"].push(item);
        }
        return data;
    }
}

export interface ITenantConfig {
    emailScope: string;
    emailSenderDomain: string;
    directMailProvider: string;
    emailTemplateOptOut: boolean | null;
    generic: { [key: string]: any; };
    authPath: string | null;
    partnerKBUrl: string | null;
    warmupDomains: string[] | null;
}

export class TenantDetail implements ITenantDetail {
    internalId!: string;
    externalId!: string;
    partnerId!: string;
    partnerName!: string;
    displayName!: string;
    status!: TenantStatus;
    configs!: TenantConfig;
    partnerDetail!: PartnerDetail;

    constructor(data?: ITenantDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.configs = new TenantConfig();
            this.partnerDetail = new PartnerDetail();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalId = _data["internalId"] !== undefined ? _data["internalId"] : <any>null;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : <any>null;
            this.partnerId = _data["partnerId"] !== undefined ? _data["partnerId"] : <any>null;
            this.partnerName = _data["partnerName"] !== undefined ? _data["partnerName"] : <any>null;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.configs = _data["configs"] ? TenantConfig.fromJS(_data["configs"]) : new TenantConfig();
            this.partnerDetail = _data["partnerDetail"] ? PartnerDetail.fromJS(_data["partnerDetail"]) : new PartnerDetail();
        }
    }

    static fromJS(data: any): TenantDetail {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalId"] = this.internalId !== undefined ? this.internalId : <any>null;
        data["externalId"] = this.externalId !== undefined ? this.externalId : <any>null;
        data["partnerId"] = this.partnerId !== undefined ? this.partnerId : <any>null;
        data["partnerName"] = this.partnerName !== undefined ? this.partnerName : <any>null;
        data["displayName"] = this.displayName !== undefined ? this.displayName : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["configs"] = this.configs ? this.configs.toJSON() : <any>null;
        data["partnerDetail"] = this.partnerDetail ? this.partnerDetail.toJSON() : <any>null;
        return data;
    }
}

export interface ITenantDetail {
    internalId: string;
    externalId: string;
    partnerId: string;
    partnerName: string;
    displayName: string;
    status: TenantStatus;
    configs: TenantConfig;
    partnerDetail: PartnerDetail;
}

export class TenantOverview implements ITenantOverview {
    tenantCount!: number;
    tenants!: Tenant[] | null;

    constructor(data?: ITenantOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantCount = _data["tenantCount"] !== undefined ? _data["tenantCount"] : <any>null;
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants!.push(Tenant.fromJS(item));
            }
            else {
                this.tenants = <any>null;
            }
        }
    }

    static fromJS(data: any): TenantOverview {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantCount"] = this.tenantCount !== undefined ? this.tenantCount : <any>null;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item ? item.toJSON() : <any>null);
        }
        return data;
    }
}

export interface ITenantOverview {
    tenantCount: number;
    tenants: Tenant[] | null;
}

export enum TenantStatus {
    NONE = "NONE",
    NEW = "NEW",
    ONBOARDING = "ONBOARDING",
    ACTIVE = "ACTIVE",
    SUSPENDED = "SUSPENDED",
    DELETED = "DELETED",
}